import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const HamburgerIcon = ({
  title = 'Hamburger',
  viewBox = '0 0 24 24',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    {/* prettier-ignore */}
    <path d="M21.882 4a1.618 1.618 0 0 1 .095 3.233l-.095.003H1.618a1.618 1.618 0 0 1-.095-3.233L1.618 4h20.264ZM21.882 11a1.618 1.618 0 0 1 .095 3.233l-.095.003H1.618a1.618 1.618 0 0 1-.095-3.233L1.618 11h20.264ZM21.882 18a1.618 1.618 0 0 1 .095 3.233l-.095.003H1.618a1.618 1.618 0 0 1-.095-3.233L1.618 18h20.264Z" />
  </CreateIconComponent>
);

export default HamburgerIcon;
